<template>
  <div class="app-layout" :inert="modal">
    <!-- サイドメニュー（CSS管理） -->
    <Menu v-if="!$route.meta?.hideMenu" />

    <!-- 右側 -->
    <div class="right-side">
      <!-- メイン -->
      <main>
        <HeaderForContents v-if="headerType === 'contents'" />
        <HeaderForSettings v-else-if="headerType === 'settings'" />
        <router-view />
      </main>

      <Footer />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, watch, onUnmounted } from 'vue'
import { useRoute } from 'vue-router'
import Menu from '@/components/menu/SkyvizMenu.vue'
import HeaderForContents from '@/components/header/HeaderForContents.vue'
import HeaderForSettings from '@/components/header/HeaderForSettings.vue'
import Footer from '@/components/footer/SkyvizFooter.vue'
import { useNoticeModalStore } from '@/stores/noticeModal'
import { useMapModalStore } from '@/stores/mapModal'
import { useConfirmModalStore } from '@/stores/confirmModal'

const route = useRoute()

const headerType = computed(() => route.meta.headerType)

const noticeModal = useNoticeModalStore()
const mapModal = useMapModalStore()
const confirmModal = useConfirmModalStore()

const modal = computed(() => noticeModal.visible || mapModal.visible)

// モーダルが開かれているとき、スクロール禁止
watch(
  () => mapModal.visible || confirmModal.visible,
  (open) => {
    if (open) {
      document.body.classList.add('no-scroll')
    } else {
      document.body.classList.remove('no-scroll')
    }
  },
  { immediate: true },
)

onUnmounted(() => {
  document.body.classList.remove('no-scroll')
})
</script>
<style>
.app-layout {
  display: flex;
  min-height: 100vh;
}

.main-navigation {
  width: 240px;
  flex-shrink: 0;
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
}

.right-side {
  margin-left: 240px;
  flex: 1;
  min-width: 0;
}
@media (max-width: 767px) {
  .right-side {
    margin-left: 0 !important;
  }
  .main-navigation.global-nav {
    position: fixed;
    top: 0;
    right: 0;
    left: auto;

    width: 80%;
    max-width: 320px;

    height: 100dvh;
    max-height: 100dvh;

    background: #fff;
    z-index: 9999;

    transform: translateX(100%);
    transition: transform 0.3s ease;

    overflow: hidden;
    box-sizing: border-box;
  }

  .main-navigation.global-nav.is-open {
    transform: translateX(0);
    height: auto !important;
    max-height: none !important;
  }
  .main-navigation.global-nav nav {
    height: 100%;
    overflow-y: auto;
  }
}
</style>
